import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ISchemasEnum } from '@qtek/shared/models';

export const SchemaEditorActions = createActionGroup({
  source: 'Schemas',
  events: {
    'Connect Schemas': props<{ mysid: string }>(),
    'Disconnect Schemas': props<{ mysid: string }>(),
    'Get Schemas Success': props<{ schemas: ISchemasEnum[] }>(),
    'Get Schemas Failure': emptyProps(),
    'Get Schema': props<{ sid: string }>(),
    'Get Schema Success': props<{ schema: ISchemasEnum }>(),
    'Get Schema Failure': props<{ error: any }>(),
    'Set  Selected Schema': props<{ sid: string }>(),
    'Update Schema': props<{ payload: ISchemasEnum }>(),
    'Update SchemaSuccess': props<{ schema: ISchemasEnum }>(),
    'Update SchemaFailure': props<{ error: any }>(),
  },
});
